export const TOKEN_EXPIRED_ERROR = 'TokenExpiredError';
